export default __webpack_public_path__ + "3e7ab7ed46b3f3d7c0cbf65dc386f90a.png";